/**
 * @class ThreeJuly
 * @param element HTMLElement
 * @constructor
 */
function ThreeJuly(element){
	this._document = element.ownerDocument;
	this._window = this._document.defaultView;
	this._popstateHandlerBound = this._popstateHandler.bind(this);
	this._document.addEventListener("DOMContentLoaded", this._contentLoadedHandler.bind(this), false);
}
/** @type DocumentView */
ThreeJuly.prototype._window = null;
/** @type HTMLDocument */
ThreeJuly.prototype._document = null;
/** @type Header */
ThreeJuly.prototype._header = null;
/** @type ObjectVR */
ThreeJuly.prototype._objectVR = null;
/** @type {Home|Apps|App|Contact} */
ThreeJuly.prototype._content = null;
/** @type {HTMLElement} */
ThreeJuly.prototype._contentElement = null;
/** @type {HTMLElement} */
ThreeJuly.prototype._nextContentElement = null;
ThreeJuly.prototype._completeWithContentEndTimeoutID = 0;
/**
 * Store current location (use to detect popstate diff)
 * @type {Object}
 * @private
 */
ThreeJuly.prototype._location = null;
/**
 * Store next location while loading its content
 * @type {Object}
 * @private
 */
ThreeJuly.prototype._nextLocation = null;
/**
 * Should state must be pop (false when content is changed after a popstate event)
 * @type {boolean}
 * @private
 */
ThreeJuly.prototype._willPushState = false;
/** @type {XMLHttpRequest} */
ThreeJuly.prototype._contentLoader = null;
ThreeJuly.prototype._popstateHandlerBound = null;
/**
 * App ready handler
 * @param event Event
 * @private
 */
ThreeJuly.prototype._contentLoadedHandler = function contentLoadedHandler(event){
	this._document.removeEventListener("DOMContentLoaded", this._contentLoadedHandler.bind(this), false);

	//TODO handle ajax and create/delete submodules
	/** @type NodeList */
	var elements;
	// Header
	if((elements = document.getElementsByClassName("header")).length){
		this._header = new Header(elements[0]);
	}

	// Only use History State when it's available (not in IE9)
	this._contentElement = this._document.getElementsByClassName("main")[0];
	if("pushState" in window.history){
		this._document.addEventListener("click", this._clickHandler.bind(this), false);
		this._window.addEventListener("popstate", this._popstateHandlerBound, false);
		var location = this._window.location;
		this._location = {
//			hash: location.hash,
//			host: location.host,
//			hostname: location.hostname,
//			href: location.href,
//			origin: location.origin,//Not supported by IE
			pathname: location.pathname,
//			port: location.port,
//			protocol: location.protocol,
			search: location.search
		};
	}
	this._initContent();
};

ThreeJuly.prototype._clickHandler = function _clickHandler(event){
	// If default action is canceled
	if(event.defaultPrevented){
		event.preventDefault();
		return;
	}

	// Native actions (download, open in new tab, etc.)
	// Only Left button (or Right button for left-handed use mouses)
	if(event.button != 0 || event.altKey || event.ctrlKey || event.metaKey){
		return;
	}

	/** @type Node */
	// Search clicked links (could be one of the ancestor of the target)
	var element = event.target;
	var location = this._window.location;
	var locationHashIndex;
	var elementHashIndex;
	while(element){
		if(element.nodeName == "A"){
			// Check target (window name)
			if(element.target != "" && element.target != "_self" && element.target != this._window.name){
				return;
			}

			locationHashIndex = location.href.indexOf("#");
			if(locationHashIndex < 0){
				locationHashIndex = location.href.length;
			}
			elementHashIndex = element.href.indexOf("#");
			if(elementHashIndex < 0){
				elementHashIndex = element.href.length;
			}

			// If same protocol, hostname, port, but not same-page anchor
			if(
				element.protocol == location.protocol
				&& element.hostname == location.hostname
				// If port undefined: IE give HTMLAnchorElement.port !== window.location.port
				&& (element.port == location.port || element.port == 80 && location.port == "")
				// Exclude same-page anchors
				&& !(
					// Full test (protocol, hostname, pathname, search), exclude that hash part ("#...")
					element.href.substring(0, elementHashIndex) == location.href.substring(0, locationHashIndex)
					// Test the hash: "", "#" or "#something". For that we need to compare the absolute href
					&& element.href.substr(elementHashIndex) != location.href.substr(locationHashIndex)
				)
			){
				event.preventDefault();
				// If it's a new location, load or reload the new content
				if(
					// No loading content and different that the current one
					this._nextLocation == null && (element.pathname != location.pathname || element.search != location.search)
					// Or different than the loading content
					|| element.pathname != this._nextLocation.pathname || element.search != this._nextLocation.search
				){
					this._loadContent(element, true);
				}
				// hash can change, just update it
				else if(this._nextLocation != null && element.href != this._nextLocation.href){
					this._updateNextLocation(element);
				}
			}

			return;
		}
		element = element.parentElement;
	}
};

ThreeJuly.prototype._updateNextLocation = function _updateNextLocation(location){
	if(this._nextLocation){
//		this._nextLocation.hash = location.hash;
//		this._nextLocation.host = location.host;
//		this._nextLocation.hostname = location.hostname;
		this._nextLocation.href = location.href;
//		this._nextLocation.origin = location.origin;//Not supported by IE
		this._nextLocation.pathname = location.pathname;
//		this._nextLocation.port = location.port;
//		this._nextLocation.protocol = location.protocol;
		this._nextLocation.search = location.search;
	}else{
		this._nextLocation = {
//			hash: location.hash,
//			host: location.host,
//			hostname: location.hostname,
			href: location.href,
//			origin: location.origin,//Not supported by IE
			pathname: location.pathname,
//			port: location.port,
//			protocol: location.protocol,
			search: location.search
		};
	}
};

// This event could be triggered when the page is loaded for the first time (WebKit)
// See https://developer.mozilla.org/en-US/docs/WindowEventHandlers.onpopstate
ThreeJuly.prototype._popstateHandler = function _popstateHandler(event) {
	var location = this._window.location;
	if(
		// If it's not loading, but location changed
		this._nextLocation == null && (location.pathname != this._location.pathname || location.search != this._location.search)
		// Or location change while loading, restart load
		|| this._nextLocation != null && (location.pathname != this._nextLocation.pathname || location.search != this._nextLocation.search)
	){
		this._loadContent(location, false);
	}
	// If loading but hash change, just update it (pathname and search are the same, see previous condition)
	else if(this._nextLocation != null && location.href != this._nextLocation.href){
		this._updateNextLocation(location);
	}
};

ThreeJuly.prototype._loadContent = function _loadContent(location, willPushState) {
	// If it's executed during content transition
	clearTimeout(this._completeWithContentEndTimeoutID);
	this._nextContentElement = null;

	// First animate current content
	this._contentElement.classList.remove("main--current");
	this._contentElement.offsetHeight;
	this._contentElement.classList.add("main--previous");

	this._updateNextLocation(location);
	this._willPushState = willPushState;
	if(this._contentLoader){
		this._contentLoader.abort();
	}else{
		this._contentLoader = new XMLHttpRequest();
		this._contentLoader.addEventListener("load", this._contentLoadHandler.bind(this), false);
		this._contentLoader.addEventListener("error", this._contentErrorHandler.bind(this), false);
	}

	this._contentLoader.open("GET", this._nextLocation.href);
	this._contentLoader.send(null);
};

ThreeJuly.prototype._contentErrorHandler = function _contentErrorHandler(event){
	var main = this._document.createElement("main");
	// TODO add a message
	this._completeWithContent(main);
};

ThreeJuly.prototype._contentLoadHandler = function _contentLoadHandler(event){
	var contentType = this._contentLoader.getResponseHeader("Content-Type");
	// HTML content
	if(typeof(contentType) == "string" && (contentType == "text/html" || contentType.substr(0, 10) == "text/html;")){
		// XHR can also parse the document with responseType = "document" (supported by IE10+)
		// But we require more error control on it.
		if(!this._contentParser){
			this._contentParser = new DOMParser();
		}

		var contentDocument;
		var mainElement;

		try{
			contentDocument = this._contentParser.parseFromString(this._contentLoader.responseText, "text/html");
		}catch(error){
			console.warn(error);
		}

		if(contentDocument && (mainElement = contentDocument.querySelector(".body .main"))){
			this._completeWithContent(mainElement);
		}
		// We can't handle that document, redirect
		else{
			this._window.location = this._nextLocation.href;
		}
	}
	// We don't handle that type yet, redirect
	else
	{
		this._window.location = this._nextLocation.href;
	}
};

/**
 * Make the transition between the current content and the provide one
 * @param {HTMLElement} content
 * @private
 */
ThreeJuly.prototype._completeWithContent = function _completeWithContent(content){
	this._nextContentElement = content;
	// Let 400ms wait animation end
	this._completeWithContentEndTimeoutID = setTimeout(this._completeWithContentEnd.bind(this), 400);
};


/**
 * Replace previous content (clear it) with the new one and initialize it
 * Will change the current state too (if _willPushState)
 * @param {HTMLElement} content
 * @private
 */
ThreeJuly.prototype._completeWithContentEnd = function _completeWithContentEnd(content){
	if(this._willPushState){
		this._window.history.pushState(null, null, this._nextLocation.href);
	}
	//should be the same as window.location.*
	this._location.pathname = this._nextLocation.pathname;
	this._location.search = this._nextLocation.search;
	this._nextLocation = null;

	// Destroy previous content
	if(this._content){
		this._content.clear();
		this._content = null;
	}
	// Previous element
	if(this._contentElement){
		if(this._nextContentElement.ownerDocument != this._document){
			// Update title and body class
			this._document.title = this._nextContentElement.ownerDocument.title;
			this._document.body.className = this._nextContentElement.ownerDocument.body.className + " body--js";
			// current document adopt the provided note
			this._nextContentElement = this._document.adoptNode(this._nextContentElement);
		}
		// Replace element tree
		this._contentElement.parentNode.replaceChild(this._nextContentElement, this._contentElement);
	}
	this._contentElement = this._nextContentElement;
	this._nextContentElement = null;
	this._initContent();
};

/**
 * Initialize content
 * @param {boolean} [first=false] First (not loaded by ajax)
 * @private
 */
ThreeJuly.prototype._initContent = function _initContent(first) {

	// Home
	if(this._contentElement.classList.contains("index_main")){
		this._content = new Home(this._contentElement);
	}

	// Apps
	else if(this._contentElement.classList.contains("apps_main")){
		this._content = new Apps(this._contentElement);
	}

	// App
	else if(this._contentElement.classList.contains("app_main")){
		this._content = new App(this._contentElement);
	}

	// Contact
	else if(this._contentElement.classList.contains("contact_main")){
		this._content = new Contact(this._contentElement);
	}

	this._contentElement.classList.add("main--current");

	this._window.scrollTo(0, 0);
	if(!first){
		/*
		Analytics
		 */
		// GA
		if("_gaq" in this._window){
			this._window._gaq.push(['_trackPageview']);
		}
	}
};